import { useContext } from 'react';
import ConfigContext from './ConfigContext.js';
export default function useConfig() {
  return useContext(ConfigContext);
}